<template>
  <div>
    <v-dialog v-model="dialog" persistent width="720" scrollable>
      <v-card>
        <v-card-title class="text-wrap">Licence Expérience FFTRI</v-card-title>
        <v-card-text>
          <v-alert type="info" density="compact" class="mb-4">
            Cette licence doit être achetée pour participer à l'épreuve en non-licencié FFTRI compétition.
          </v-alert>
          <div v-if="loading_price" class="text-center py-4">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
          <div v-else>
            <p class="font-weight-bold mb-4">Prix de la licence : {{ formatted_price }}</p>
            <v-switch v-model="receivePromo" color="primary" hide-details density="compact"
              label="J'accepte de recevoir des informations promotionnelles par email (RGPD)"></v-switch>
            <v-switch v-model="sendInvoice" color="primary" hide-details density="compact" class="mb-4"
              label="Je souhaite recevoir une facture pour cette licence"></v-switch>
            <v-divider class="my-3"></v-divider>
            <p class="font-weight-bold mb-2">Formulaire information santé</p>
            <p class="text-caption mb-3">Cochez chaque case pour confirmer que vous n'êtes pas concerné(e) par la situation
              décrite.</p>
            <v-checkbox v-for="item in health_items" :key="item.key" v-model="health_form[item.key]" hide-details
              density="compact" class="mb-1">
              <template #label>
                <span class="text-wrap">{{ item.label }}</span>
              </template>
            </v-checkbox>
            <v-checkbox v-model="health_form.certification" hide-details density="compact" class="mt-3">
              <template #label>
                <span class="text-wrap">Je certifie avoir lu et complété ce formulaire information santé de manière
                  sincère.</span>
              </template>
            </v-checkbox>
          </div>
        </v-card-text>
        <v-card-actions class="flex-column flex-sm-row gap pa-4">
          <v-btn @click="$emit('unvalidate')" color="dark-red" class="sm-fullwidth">Annuler</v-btn>
          <v-btn @click="confirm" color="dark-green" class="sm-fullwidth" :disabled="!can_confirm || loading_price">
            Confirmer et ajouter au panier
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PublicService from "@/services/public.service";
export default {
  props: ["inscription"],
  data() {
    return {
      dialog: true,
      loading_price: true,
      prix: 0,
      currency: "EUR",
      receivePromo: false,
      sendInvoice: true,
      id_course: null,
      type_licence_experience: "",
      health_form: {},
      health_items: [
        { key: "health_cardio", label: "Je n'ai pas d'antécédent cardiaque ni de malaise inexpliqué." },
        { key: "health_chest_pain", label: "Je n'ai pas ressenti de douleur thoracique, palpitations ou essoufflement inhabituel récemment." },
        { key: "health_loss_consciousness", label: "Je n'ai pas eu de perte de connaissance récente." },
        { key: "health_treatment", label: "Je n'ai pas de traitement médical de longue durée incompatible avec la pratique." },
        { key: "health_injury", label: "Je ne suis pas en arrêt sportif pour blessure ou maladie non autorisé médicalement." },
      ],
    };
  },
  computed: {
    formatted_price() {
      if (this.prix == null || isNaN(this.prix)) return "—";
      return new Intl.NumberFormat("fr-FR", { style: "currency", currency: this.currency || "EUR" }).format(this.prix);
    },
    can_confirm() {
      for (const item of this.health_items) {
        if (!this.health_form[item.key]) return false;
      }
      return !!this.health_form.certification && this.prix > 0;
    },
  },
  methods: {
    init_health_form() {
      const form = { certification: false };
      for (const item of this.health_items) {
        form[item.key] = false;
      }
      this.health_form = form;
    },
    get_selected_course() {
      const selected = this.inscription.list_courses.list.filter((c) => c.selected);
      return selected.length > 0 ? selected[0] : null;
    },
    async fetch_price() {
      this.loading_price = true;
      const course = this.get_selected_course();
      if (!course) {
        this.loading_price = false;
        return;
      }
      this.id_course = course.id;
      this.type_licence_experience = course.metadatas?.type_licence_experience || "";
      const res = await PublicService.getLicenceExperiencePrice(this.id_course, this.type_licence_experience);
      if (res && res.prix != null) {
        this.prix = parseFloat(res.prix);
        this.currency = res.currency || "EUR";
      }
      this.loading_price = false;
    },
    confirm() {
      if (!this.can_confirm) return;
      this.$emit("validate", {
        prix: this.prix,
        receivePromo: this.receivePromo ? 1 : 0,
        sendInvoice: this.sendInvoice ? 1 : 0,
        health_form: { ...this.health_form },
        id_course: this.id_course,
        type_licence_experience: this.type_licence_experience,
        confirmed: true,
      });
    },
  },
  created() {
    this.init_health_form();
    this.fetch_price();
  },
};
</script>
